<template>
  <editor-bubble-menu
    plugin-key="vocabTooltip"
    :editor="editor"
    :tippy-options="{ placement: 'bottom' }"
    :should-show="shouldShow"
  >
    <editor-menu-button label="Edit" icon="pencil" @click="openModal" />
    <editor-menu-button label="Remove" icon="cancel" @click="remove" />
  </editor-bubble-menu>
  <editor-modal
    v-if="isModalShown"
    class="vocab-tooltip-menu__modal"
    name="vocabTooltip"
    title="Edit Vocab Tooltip"
  >
    <async-form class="vocab-tooltip-menu__form" @submit="updateTooltip">
      <form-label for="editor-tip">Tip</form-label>
      <editor
        :text="tip"
        :disable-vocab="true"
        prevent-stringify
        :variable-context="variableContext"
        @input="arg => (tip = arg)"
      />
      <div class="editor-modal__actions">
        <form-button type="submit">Save</form-button>
        <form-button tertiary @click="cancel">Cancel</form-button>
      </div>
    </async-form>
  </editor-modal>
</template>

<script>
import * as Vue from 'vue'
import { isActive } from '@tiptap/core'
import EditorModal from '../components/EditorModal'
import EditorBubbleMenu from '../components/EditorBubbleMenu'
import EditorMenuButton from '../components/EditorMenuButton'

export default {
  name: 'VocabTooltipMenu',
  components: { EditorBubbleMenu, EditorModal, EditorMenuButton },
  props: {
    editor: {
      type: Object,
      required: true
    },
    variableContext: {
      type: Object,
      required: false
    }
  },
  setup(props) {
    const shouldShow = ({ state }) => {
      return isActive(state, 'vocabTooltip')
    }

    const remove = () => {
      props.editor.chain().focus().unsetVocabTooltip().run()
    }
    // Sync the focused node's href with the menu.
    const tip = Vue.ref(null)
    const onSelectionUpdate = () => {
      tip.value = props.editor.getAttributes('vocabTooltip').tip
    }
    props.editor.on('selectionUpdate', onSelectionUpdate)
    Vue.onUnmounted(() => {
      props.editor.off('selectionUpdate', onSelectionUpdate)
    })

    const isModalShown = Vue.ref(false)
    const openModal = () => {
      isModalShown.value = true
    }

    const updateTooltip = e => {
      props.editor
        .chain()
        .focus()
        .extendMarkRange('vocabTooltip')
        .setVocabTooltip({ tip: tip.value })
        .run()
      isModalShown.value = false
      e.done()
    }
    const cancel = e => {
      isModalShown.value = false
      props.editor.commands.focus()
    }

    // eslint-disable-next-line vue/no-mutating-props
    props.editor.storage.vocabTooltip.onEditVocabTooltip = openModal

    return {
      tip,
      isModalShown,
      shouldShow,
      remove,
      cancel,
      openModal,
      updateTooltip
    }
  }
}
</script>

<style lang="scss" scoped>
.vocab-tooltip-menu {
  &__form {
    margin: 0 !important;
  }

  &__error {
    margin: 16px 0 0 0;
    color: $color-error;
  }
}
</style>
